import List from "./List";

export const path = "/ecommerce/dashboard-liberacao";

export const ReleaseDashboard = {
  List,
  path,
  Permissions: {
    list: "list:Order",
    retry: "update:Order",
  },
};
